import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IModuleByggnadsdata, IModuleKylaVattenburet, IModuleLokaler, IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";
import { IJ8_BFData } from "../../types/BFDatas";
import { numFrmt0Dec, numFrmtStd } from "../common";

//todo -> make class?!
export const bfv_J8 = (): IBFModule => {
  const bfName = BFLType.BFV_J8;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    let funktionsKontroller: IKontrollResultRow[] = [];
    let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    const bH = bflHelper.bflHelper();
    const debug = {} as any;
    const data = {} as any;
    let error: any = undefined;
    try {
      const byggnadsModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const byggnadModuleData = byggnadsModule?.data as IModuleByggnadsdata;
      const lokalerModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler);
      const lokalerModuleData = lokalerModule?.data as IModuleLokaler;
      const moduleData = module.data as IModuleVattenburetSekundärsystem;
      formData = (formData?.data || module.bfs?.BFV_J8?.data) as IJ8_BFData | undefined;

      debug["BIM"] = {
        G11_GeografiskJusteringsFaktor: bimHandler.G11_GeografiskJusteringsFaktor,
        G13_ÅrligBruttoAnvändningCentralVärme: bimHandler.G13_ÅrligBruttoAnvändningCentralVärme(),
        G17_BruttoEnergiVentilation_FTX: bimHandler.G17_BruttoEnergiVentilation_FTX(),
        G17_BruttoEnergiVentilation_FX: bimHandler.G17_BruttoEnergiVentilation_FX(),
        G17_BruttoEnergiVentilation_s: bimHandler.G17_BruttoEnergiVentilation_s(),
        G17_BruttoEnergiVentilation: bimHandler.G17_BruttoEnergiVentilation(),
        G19_BruttoEnergiTappvatten: bimHandler.G19_BruttoEnergiTappvatten,
        G15_BruttoAnvändningTransmission: bimHandler.G15_BruttoAnvändningTransmission(),
        BIM_Pumpstopp_UteTemperatur: bimHandler.BIM_Pumpstopp_UteTemperatur,
      };

      //Hittar kylen som betjänar störst gemensam yta
      const roundData = roundHandler.getRoundData();
      const arrKylSystemMedGemensamBetjäningsyta = roundData?.data.modules.filter(
        (m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet && (m.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta?.find((r) => r.värmeModulId === module.id),
      );
      let modKylSystemStörstGemensamYta: IModuleRound | undefined = undefined;
      let ytaProcentSomBetjänasMedKomfortKyla = 0;
      if (arrKylSystemMedGemensamBetjäningsyta?.length) {
        for (var mi = 0; mi < arrKylSystemMedGemensamBetjäningsyta?.length; mi++) {
          const modKylSystem = arrKylSystemMedGemensamBetjäningsyta[mi];
          const gemensamBetjäningsytaAndel = (modKylSystem.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta.find((g) => g.värmeModulId === module.id);
          if (gemensamBetjäningsytaAndel?.ytaAndel && gemensamBetjäningsytaAndel?.ytaAndel > ytaProcentSomBetjänasMedKomfortKyla) {
            modKylSystemStörstGemensamYta = modKylSystem;
            ytaProcentSomBetjänasMedKomfortKyla = gemensamBetjäningsytaAndel.ytaAndel;
          }
        }
      }

      const j8ShuntensSystemAndel = moduleData.värmeSystemandel / 100;

      const j8funktionsfelPumpstoppBeräkningsvärde = bimHandler.BIM_Pumpstopp_UteTemperatur;
      const j8TempPumpstopp = moduleData.pumpstoppInstallning;
      data["pumpstoppInstallning"] = j8TempPumpstopp;
      //j8gränsvärdePumpstopp=IF(j8formPumpstoppAktiveras="Ja";j8TempPumpstopp;j8funktionsfelPumpstoppBeräkningsvärde)
      const j8gränsvärdePumpstopp = formData?.pumpstoppAktiveras === "Ja" ? j8TempPumpstopp : j8funktionsfelPumpstoppBeräkningsvärde;
      const j8gränsvärdeOptimeratPumpstopp = bimHandler.BIM_Schablon_TempOptimeratPumpstopp;
      const j8fGeo = bimHandler.G11_GeografiskJusteringsFaktor;
      const j8ÅrligEnergiTransmission = bimHandler.G15_BruttoAnvändningTransmission();

      const värmekälla = bimHandler.energiKälla;

      //Total ch för pumpstopp
      const x17 = j8gränsvärdeOptimeratPumpstopp < 17 ? (17 - j8gränsvärdeOptimeratPumpstopp) * 8000 : 0;
      const x18 = j8gränsvärdePumpstopp > 17 ? Math.min(1, j8gränsvärdePumpstopp - 17) * 8000 : 0;
      const x19 = j8gränsvärdePumpstopp > 18 ? Math.min(1, j8gränsvärdePumpstopp - 18) * 6500 : 0;
      const x20 = j8gränsvärdePumpstopp > 19 ? Math.min(1, j8gränsvärdePumpstopp - 19) * 4500 : 0;
      const x21 = j8gränsvärdePumpstopp > 20 ? Math.min(1, j8gränsvärdePumpstopp - 20) * 1500 : 0;
      const j8summaCh = (x17 + x18 + x19 + x20 + x21) / (j8fGeo ?? 1);
      const j8andelAvTotalCh = j8summaCh / 131600;

      const j8VägledandeVerkningsgrad = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;
      //j8överkonsumtionElVärme=IF(OR(j8Värmekälla=j8_vkälla_markvärmepump;j8Värmekälla=j8_vkälla_Frånluftsvärmepump;j8Värmekälla=j8_vkälla_frånluftvärmepumpMedInverter;j8Värmekälla=j8_vkälla_värmepump_LuftLuft;j8Värmekälla=j8_vkälla_elpanna;j8Värmekälla=j8_vkälla_dirEl);j8ÅrligEnergiTransmission*j8shuntgruppensSystemAndel*j8andelAvTotalCh/j8VägledandeVerkningsgrad;0)

      const j8överkonsumtionElVärme = ["Markvärmepump", "Frånluftsvärmepump", "Frånluftvärmepump med inverter", "Värmepump Luft/Luft", "Elpanna", "Direktverkande el"].includes(värmekälla)
        ? (j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh) / j8VägledandeVerkningsgrad
        : 0;

      //j8överkonsumtionVärme=IF(OR(j8Värmekälla=j8_vkälla_Fjärr;j8Värmekälla=j8_vkälla_BiobränslePanna;j8Värmekälla=j8_vkälla_gaspana;j8Värmekälla=j8_vkälla_oljepanna);j8ÅrligEnergiTransmission*j8shuntgruppensSystemAndel*j8andelAvTotalCh/j8VägledandeVerkningsgrad;0)
      const j8överkonsumtionVärme = ["Fjärrvärme", "Biobränslepanna", "Gaspanna", "Oljepanna"].includes(värmekälla)
        ? (j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh) / j8VägledandeVerkningsgrad
        : 0;

      const j8schablonEnergiKyla = bimHandler.BIM_Schablon_EnergiKyla;
      let j8överkonsumtionElproduceradKyla = 0;
      let j8överkonsumtionFjärrkylaBeräknad = 0;
      let j8överkonsumtionAbsoptionsKyla = 0;
      let j8normalEnergianvändningKyla = 0;
      let j8ärKylaAktivt = false;
      let j8kylfaktor = 1;
      let j8ytasombetjänasMedKylaProcent = 0;
      let j8kylform = "";
      let j8kylfaktorFjärrvärme = 1;
      //Beräkning komfortkyla
      if (modKylSystemStörstGemensamYta) {
        const kylSystemData = modKylSystemStörstGemensamYta.data as IModuleKylaVattenburet;
        j8kylform = kylSystemData.kylform;
        const kylformRow = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === j8kylform);
        j8kylfaktor = kylformRow?.Faktor ?? 0;

        j8ytasombetjänasMedKylaProcent = ytaProcentSomBetjänasMedKomfortKyla / 100;

        const anyRowsWhenKylaAktivt = lokalerModuleData.stickprov.filter((r) => r.värmeSystem === module.name && r.komfortKylaAktiv === "Ja");
        j8ärKylaAktivt = anyRowsWhenKylaAktivt.length > 0 ? true : false;
        //j8ärKylaAktivt = anyRowsWhenKylaAktivt ? true : false;

        const kylFaktorRow = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === j8kylform);
        //Använd logik från ovan för att bestämma om kylfaktor = 1 eller 0.65...
        j8kylfaktorFjärrvärme = j8kylform === "Absorptionskyla" ? 0.65 : 1;
        j8normalEnergianvändningKyla = j8kylfaktor === 0 ? 0 : (byggnadModuleData.byggnadArea * j8ShuntensSystemAndel * j8ytasombetjänasMedKylaProcent * j8schablonEnergiKyla) / j8kylfaktor;
        //j8överkonsumtionElproduceradKyla = IF(AND(NOT(j8kylform='Grunddata IN'!AA14);AND(j8ärKylaAktivt="Ja";j8överkonsumtionElVärme+j8överkonsumtionVärme>0,5));(j8ÅrligEnergiTransmission*j8shuntgruppensSystemAndel*j8andelAvTotalCh)/j8kylfaktor*j8ytasombetjänasMedKylaProcent;0)
        j8överkonsumtionElproduceradKyla =
          j8kylform !== "Fjärrkyla" && j8ärKylaAktivt && j8överkonsumtionElVärme + j8överkonsumtionVärme > 0.5 && j8kylfaktor > 0
            ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh) / j8kylfaktor) * j8ytasombetjänasMedKylaProcent
            : 0;

        //j8överkonsumtionFjärrkylaBeräknad =IF(AND(j8ärKylaAktivt="Ja";j8kylform='Grunddata IN'!AA14;j8överkonsumtionElVärme+j8överkonsumtionVärme>0,5);(j8ÅrligEnergiTransmission*j8shuntgruppensSystemAndel*j8andelAvTotalCh)/j8kylfaktor*j8ytasombetjänasMedKylaProcent;0)
        j8överkonsumtionFjärrkylaBeräknad =
          j8ärKylaAktivt && j8kylform === "Fjärrkyla" && j8överkonsumtionElVärme + j8överkonsumtionVärme > 0.5 && j8kylfaktor > 0
            ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh) / j8kylfaktor) * j8ytasombetjänasMedKylaProcent
            : 0;

        //j8överkonsumtionAbsoptionsKyla =IF(AND(j8ärKylaAktivt="Ja";j8kylform='Grunddata IN'!AA13;j8överkonsumtionElVärme+j8överkonsumtionVärme>0,5);(j8ÅrligEnergiTransmission*j8shuntgruppensSystemAndel*j8andelAvTotalCh)/j8kylfaktorFjärrvärme*j8ytasombetjänasMedKylaProcent;0)
        j8överkonsumtionAbsoptionsKyla =
          j8ärKylaAktivt && j8kylform === "Absorptionskyla" && j8överkonsumtionElVärme + j8överkonsumtionVärme > 0.5 && j8kylfaktorFjärrvärme > 0
            ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh) / j8kylfaktorFjärrvärme) * j8ytasombetjänasMedKylaProcent
            : 0;
      }

      //const j8överkonsumtionElprodKyla =IF(AND(j8överkonsumtionElVärme+j8överkonsumtionVärme>0,5;B75="Ja");B78;0)
      const j8överkonsumtionElprodKyla = j8överkonsumtionElVärme + j8överkonsumtionVärme > 0.5 ? j8överkonsumtionElproduceradKyla : 0;
      //j8överkonsumtionFjärrkyla =IF(AND(j8överkonsumtionElVärme+j8överkonsumtionVärme>0,5;j8ärKylaAktivt="Ja");j8överkonsumtionFjärrkylaBeräknad;0)
      const j8överkonsumtionFjärrkyla = j8överkonsumtionElVärme + j8överkonsumtionVärme > 0.5 && j8ärKylaAktivt ? j8överkonsumtionFjärrkylaBeräknad : 0;
      //j8överkonsumtionAbsorbtionskyla=IF(AND(j8överkonsumtionElVärme+j8överkonsumtionVärme>0,5;j8ärKylaAktivt="Ja");j8överkonsumtionAbsoptionsKyla;0)
      const j8överkonsumtionAbsorbtionskyla = j8överkonsumtionElVärme + j8överkonsumtionVärme > 0.5 && j8ärKylaAktivt ? j8överkonsumtionAbsoptionsKyla : 0;
      debug["Tabell 1"] = {
        "1. Vilkorsstyrt gränsvärde pumpstopp": j8gränsvärdePumpstopp,
        "2. Gränsvärde för optimerat pumpstopp ≤°C": j8gränsvärdeOptimeratPumpstopp,
        "3. Funktionsfel pumpstopp, beräkningsvärde ( 'Nej' Cell F22)": j8funktionsfelPumpstoppBeräkningsvärde,
        "4. Geografisk justeringsfaktor": j8fGeo,
        "5. Årlig energi transmission (kWh)": j8ÅrligEnergiTransmission,
        "6. Shuntgruppens systemandel (%)": moduleData.värmeSystemandel + "%",
        "7. Andel av total °Ch": j8andelAvTotalCh,
        "8. Värmekälla": värmekälla,
        "9. Vägledande verkningsgrad": j8VägledandeVerkningsgrad,
        "10. Överkonsumtion EL värme (kWh/år)": j8överkonsumtionElVärme,
        "11. Överkonsumtion värme (kWh/år)": j8överkonsumtionVärme,
        "12. Överkonsumtion elproducerad kyla (kWh/år)": j8överkonsumtionElproduceradKyla,
        "13. Överkonsumtion fjärrkyla (kWh/år)": j8överkonsumtionFjärrkyla,
        "14. Överkonsumtion Absorptionskyla (kWh Fjärrvärme/år)": j8överkonsumtionAbsorbtionskyla,
        j8TempPumpstopp,
        j8summaCh,
      };

      //Beräkning elanvändning för pumpdrift
      const j8cirkulationspumpEffekt = moduleData.elEffekt;
      const j8timmarPerGrad =
        (globalData.BFV_J9.tempFordelning__2_0[0]["Timmar / °C"] +
          globalData.BFV_J9.tempFordelning_0_2[0]["Timmar / °C"] +
          globalData.BFV_J9.tempFordelning_2_4[0]["Timmar / °C"] +
          globalData.BFV_J9.tempFordelning_4_6[0]["Timmar / °C"] +
          globalData.BFV_J9.tempFordelning_6_8[0]["Timmar / °C"]) /
        5;

      //todo : Logik för att ersätta j8TempPumpstopp="Saknas" saknas. Inför i ronderingsdata/formulär checkbox för pumpstopp saknas.
      const j8TempPumpstoppSaknas = moduleData.pumpstoppSaknas;
      //const j8FörändringNyttPumpstopp=IF(OR(j8TempPumpstopp="Saknas";j8formPumpstoppAktiveras="Nej");0;(j8TempPumpstopp-j8nyInställningPumpstopp)*j8timmarPerGrad/j8fGeo*j8cirkulationspumpEffekt/1000)
      const j8FörändringNyttPumpstopp =
        formData?.pumpstoppAktiveras === "Nej" || j8TempPumpstoppSaknas
          ? 0
          : ((((j8TempPumpstopp - (formData?.nyInställningPumpstopp ?? 0)) * j8timmarPerGrad) / (j8fGeo ?? 0)) * j8cirkulationspumpEffekt) / 1000;
      //const j8överkonsumtionEL =IF(OR(j8TempPumpstopp="Saknas";j8formPumpstoppAktiveras:H26="Nej");(BIM_Pumpstopp_UteTemperatur-j8gränsvärdeOptimeratPumpstopp)*j8timmarPerGrad/j8fGeo*j8cirkulationspumpEffekt/1000;(j8TempPumpstopp-j8gränsvärdeOptimeratPumpstopp)*j8timmarPerGrad/j8fGeo*j8cirkulationspumpEffekt/1000)
      const j8överkonsumtionEL =
        j8TempPumpstoppSaknas || formData?.pumpstoppAktiveras === "Nej"
          ? ((bimHandler.BIM_Pumpstopp_UteTemperatur - j8gränsvärdeOptimeratPumpstopp) * j8timmarPerGrad * (j8fGeo ?? 0) * j8cirkulationspumpEffekt) / 1000
          : ((((j8TempPumpstopp - j8gränsvärdeOptimeratPumpstopp) * j8timmarPerGrad) / (j8fGeo ?? 0)) * j8cirkulationspumpEffekt) / 1000;

      debug["Beräkning elanvändning för pumpdrift"] = {
        "15. Befintligt pumpstopp": j8TempPumpstopp,
        "16. Cirkulationspumpens EL effekt (W)": j8cirkulationspumpEffekt,
        "17. Timmar per °C enl. varaktigh. Diagr.": j8timmarPerGrad,
        "18. Förändring nytt pumpstopp EL (kWh)": j8FörändringNyttPumpstopp,
        "19. Överkonsumtion EL (kWh)": j8överkonsumtionEL,
      };

      const j8nyInställningPumpstopp = formData?.nyInställningPumpstopp ?? 0;

      //Besparingspotential
      const x17_besparingNyttVärde = j8nyInställningPumpstopp < 17 && j8nyInställningPumpstopp < j8TempPumpstopp ? (j8TempPumpstopp - j8nyInställningPumpstopp) * 8000 : 0;
      const x18_besparingNyttVärde =
        j8nyInställningPumpstopp < 18 && j8TempPumpstopp >= 17 && j8nyInställningPumpstopp < j8TempPumpstopp ? (Math.min(j8TempPumpstopp, 18) - Math.max(j8nyInställningPumpstopp, 17)) * 8000 : 0;
      const x19_besparingNyttVärde =
        j8nyInställningPumpstopp < 19 && j8TempPumpstopp >= 18 && j8nyInställningPumpstopp < j8TempPumpstopp ? (Math.min(j8TempPumpstopp, 19) - Math.max(j8nyInställningPumpstopp, 18)) * 6500 : 0;
      const x20_besparingNyttVärde =
        j8nyInställningPumpstopp < 20 && j8TempPumpstopp >= 19 && j8nyInställningPumpstopp < j8TempPumpstopp ? (Math.min(j8TempPumpstopp, 20) - Math.max(j8nyInställningPumpstopp, 19)) * 4500 : 0;
      const x21_besparingNyttVärde =
        j8nyInställningPumpstopp < 21 && j8TempPumpstopp >= 20 && j8nyInställningPumpstopp < j8TempPumpstopp ? (j8TempPumpstopp - Math.max(j8nyInställningPumpstopp, 20)) * 1500 : 0;

      const j8summaCh_besparingNyttVärde = (x17_besparingNyttVärde + x18_besparingNyttVärde + x19_besparingNyttVärde + x20_besparingNyttVärde + x21_besparingNyttVärde) / (j8fGeo ?? 1);
      const j8andelAvTotalCh_besparingNyttVärde = j8summaCh_besparingNyttVärde / 131600;

      //j8DeltaElVärme_besp = =IF(OR(j8Värmekälla_besp=j8_vkälla_markvärmepump;j8Värmekälla_besp=j8_vkälla_Frånluftsvärmepump;j8Värmekälla_besp=j8_vkälla_frånluftvärmepumpMedInverter;j8Värmekälla_besp=j8_vkälla_värmepump_LuftLuft;j8Värmekälla_besp=j8_vkälla_elpanna;j8Värmekälla_besp=j8_vkälla_dirEl);j8ÅrligEnergiTransmission_besp*j8shuntgruppensSystemAndel_besp*j8andelAvTotalCh_besparingNyttVärde/j8VägledandeVerkningsgrad_besp;0)
      const j8DeltaElVärme_besp =
        ["Markvärmepump", "Frånluftsvärmepump", "Frånluftvärmepump med inverter", "Värmepump Luft/Luft", "Elpanna", "Direktverkande el"].includes(värmekälla) && j8VägledandeVerkningsgrad > 0
          ? (j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_besparingNyttVärde) / j8VägledandeVerkningsgrad
          : 0;

      //j8DeltaVärme_besp = =IF(OR(j8Värmekälla_besp=j8_vkälla_Fjärr;j8Värmekälla_besp=j8_vkälla_BiobränslePanna;j8Värmekälla_besp=j8_vkälla_gaspana;j8andelAvTotalCh_besparingNyttVärde=j8_vkälla_oljepanna);j8ÅrligEnergiTransmission_besp*j8shuntgruppensSystemAndel_besp*j8andelAvTotalCh_besparingNyttVärde/j8VägledandeVerkningsgrad_besp;0)
      const j8DeltaVärme_besp =
        ["Fjärrvärme", "Biobränslepanna", "Gaspanna", "Oljepanna"].includes(värmekälla) && j8VägledandeVerkningsgrad > 0
          ? (j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_besparingNyttVärde) / j8VägledandeVerkningsgrad
          : 0;
      //j8DeltaKyla_besp=IF(AND(NOT(j8kylform='Grunddata IN'!AA14);AND(j8ärKylaAktivt="Ja";j8andelAvTotalCh_besparingNyttVärde>0,005));(j8ÅrligEnergiTransmission_besp*j8shuntgruppensSystemAndel_besp*j8andelAvTotalCh_besparingNyttVärde)/j8kylfaktor*j8ytasombetjänasMedKylaProcent;0)
      const j8DeltaKyla_besp =
        j8kylform !== "Fjärrkyla" && j8ärKylaAktivt && j8andelAvTotalCh_besparingNyttVärde > 0.005 && j8kylfaktor > 0
          ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_besparingNyttVärde) / j8kylfaktor) * j8ytasombetjänasMedKylaProcent
          : 0;
      //j8DeltaFjärrkyla_besp = =IF(AND(j8ärKylaAktivt="Ja";j8kylform='Grunddata IN'!AA14;j8andelAvTotalCh_besparingNyttVärde>0,005);(j8ÅrligEnergiTransmission_besp*j8shuntgruppensSystemAndel_besp*j8andelAvTotalCh_besparingNyttVärde)/j8kylfaktor*j8ytasombetjänasMedKylaProcent;0)
      const j8DeltaFjärrkyla_besp =
        j8ärKylaAktivt && j8kylform === "Fjärrkyla" && j8andelAvTotalCh_besparingNyttVärde > 0.005 && j8kylfaktor > 0
          ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_besparingNyttVärde) / j8kylfaktor) * j8ytasombetjänasMedKylaProcent
          : 0;

      //j8DeltaAbsorptionsKyla_besp =IF(AND(j8ärKylaAktivt="Ja";j8kylform='Grunddata IN'!AA13;j8andelAvTotalCh_besparingNyttVärde>0,005);(j8ÅrligEnergiTransmission_besp*j8shuntgruppensSystemAndel_besp*j8andelAvTotalCh_besparingNyttVärde)/j8kylfaktorFjärrvärme*j8ytasombetjänasMedKylaProcent;0)
      const j8DeltaAbsorptionsKyla_besp =
        j8ärKylaAktivt && j8kylform === "Absorptionskyla" && j8andelAvTotalCh_besparingNyttVärde > 0.005 && j8kylfaktorFjärrvärme > 0
          ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_besparingNyttVärde) / j8kylfaktorFjärrvärme) * j8ytasombetjänasMedKylaProcent
          : 0;
      debug["Besparingspotential för nytt inställningsvärde"] = {
        "Förändring EL värme (kWh)": j8DeltaElVärme_besp,
        "Förändring värme (kWh)": j8DeltaVärme_besp,
        "Förändring elproducerad kyla (kWh/år)": j8DeltaKyla_besp,
        "Förändring fjärrkyla (kWh/år)": j8DeltaFjärrkyla_besp,
        "Förändring Absorptionskyla (kWh Fjärrvärme/år)": j8DeltaAbsorptionsKyla_besp,
        j8summaCh_besparingNyttVärde,
        j8andelAvTotalCh_besparingNyttVärde,
      };

      // Ökad energianvändning nytt inställningsvärde
      const x17_ökadAnvNyttVärdeOld = j8nyInställningPumpstopp < 17 && j8TempPumpstopp < j8nyInställningPumpstopp ? (j8nyInställningPumpstopp - j8TempPumpstopp) * 8000 : 0;
      const x18_ökadAnvNyttVärdeOld =
        j8nyInställningPumpstopp >= 17 && j8TempPumpstopp < 18 && j8nyInställningPumpstopp > j8TempPumpstopp ? (Math.min(18, j8nyInställningPumpstopp) - Math.max(17, j8TempPumpstopp)) * 8000 : 0;
      const x19_ökadAnvNyttVärdeOld =
        j8nyInställningPumpstopp >= 18 && j8TempPumpstopp < 19 && j8nyInställningPumpstopp > j8TempPumpstopp ? (Math.min(19, j8nyInställningPumpstopp) - Math.max(18, j8TempPumpstopp)) * 6500 : 0;
      const x20_ökadAnvNyttVärdeOld =
        j8nyInställningPumpstopp >= 19 && j8TempPumpstopp < 20 && j8nyInställningPumpstopp > j8TempPumpstopp ? (Math.min(20, j8nyInställningPumpstopp) - Math.max(19, j8TempPumpstopp)) * 4500 : 0;
      const x21_ökadAnvNyttVärdeOld =
        j8nyInställningPumpstopp >= 20 && j8TempPumpstopp < 21 && j8nyInställningPumpstopp > j8TempPumpstopp ? (Math.min(21, j8nyInställningPumpstopp) - Math.max(20, j8TempPumpstopp)) * 1500 : 0;

      const j8summaCh_ökadAnvNyttVärde = (x17_ökadAnvNyttVärdeOld + x18_ökadAnvNyttVärdeOld + x19_ökadAnvNyttVärdeOld + x20_ökadAnvNyttVärdeOld + x21_ökadAnvNyttVärdeOld) / (j8fGeo ?? 1);
      const j8andelAvTotalCh_ökadAnvNyttVärde = j8summaCh_ökadAnvNyttVärde / 131600;

      //const j8DeltaElVärme_ökad=IF(OR(j8Värmekälla_ökad=j8_vkälla_markvärmepump;j8Värmekälla_ökad=j8_vkälla_Frånluftsvärmepump;j8Värmekälla_ökad=j8_vkälla_frånluftvärmepumpMedInverter;j8Värmekälla_ökad=j8_vkälla_värmepump_LuftLuft;j8Värmekälla_ökad=j8_vkälla_elpanna;j8Värmekälla_ökad=j8_vkälla_dirEl);j8ÅrligEnergiTransmission_ökad*j8shuntgruppensSystemAndel_ökad*j8andelAvTotalCh_ökadAnvNyttVärde/j8VägledandeVerkningsgrad_ökad;0)
      const j8DeltaElVärme_ökad =
        ["Markvärmepump", "Frånluftsvärmepump", "Frånluftvärmepump med inverter", "Värmepump Luft/Luft", "Elpanna", "Direktverkande el"].includes(värmekälla) && j8VägledandeVerkningsgrad > 0
          ? (j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_ökadAnvNyttVärde) / j8VägledandeVerkningsgrad
          : 0;
      //const j8DeltaVärme_ökad=IF(OR(j8Värmekälla_ökad=j8_vkälla_Fjärr;j8Värmekälla_ökad=j8_vkälla_BiobränslePanna;j8Värmekälla_ökad=j8_vkälla_gaspana;j8Värmekälla_ökad=j8_vkälla_oljepanna);j8ÅrligEnergiTransmission_ökad*j8shuntgruppensSystemAndel_ökad*j8andelAvTotalCh_ökadAnvNyttVärde/j8VägledandeVerkningsgrad_ökad;0)
      const j8DeltaVärme_ökad =
        ["Fjärrvärme", "Biobränslepanna", "Gaspanna", "Oljepanna"].includes(värmekälla) && j8VägledandeVerkningsgrad > 0
          ? (j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_ökadAnvNyttVärde) / j8VägledandeVerkningsgrad
          : 0;
      //const j8DeltaKyla_ökad =IF(AND(NOT(j8kylform='Grunddata IN'!AA14);AND(j8ärKylaAktivt="Ja";j8andelAvTotalCh_ökadAnvNyttVärde>0,005));(j8ÅrligEnergiTransmission_ökad*j8shuntgruppensSystemAndel_ökad*j8andelAvTotalCh_ökadAnvNyttVärde)/j8kylfaktor*j8ytasombetjänasMedKylaProcent;0)
      const j8DeltaKyla_ökad =
        j8kylform !== "Fjärrkyla" && j8ärKylaAktivt && j8andelAvTotalCh_ökadAnvNyttVärde > 0.005 && j8kylfaktor > 0
          ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_ökadAnvNyttVärde) / j8kylfaktor) * j8ytasombetjänasMedKylaProcent
          : 0;

      //j8DeltaFjärrkyla_ökad =IF(AND(j8ärKylaAktivt="Ja";j8kylform='Grunddata IN'!AA14;j8andelAvTotalCh_ökadAnvNyttVärde>0,005);(j8ÅrligEnergiTransmission_ökad*j8shuntgruppensSystemAndel_ökad*j8andelAvTotalCh_ökadAnvNyttVärde)/j8kylfaktor*j8ytasombetjänasMedKylaProcent;0)
      const j8DeltaFjärrkyla_ökad =
        j8ärKylaAktivt && j8kylform === "Fjärrkyla" && j8andelAvTotalCh_ökadAnvNyttVärde > 0.005 && j8kylfaktor > 0
          ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_ökadAnvNyttVärde) / j8kylfaktor) * j8ytasombetjänasMedKylaProcent
          : 0;

      //j8DeltaAbsorptionsKyla_ökad =IF(AND(j8ärKylaAktivt="Ja";j8kylform='Grunddata IN'!AA13;j8andelAvTotalCh_ökadAnvNyttVärde>0,005);(j8ÅrligEnergiTransmission_ökad*j8shuntgruppensSystemAndel_ökad*j8andelAvTotalCh_ökadAnvNyttVärde)/j8kylfaktorFjärrvärme*j8ytasombetjänasMedKylaProcent;0)
      const j8DeltaAbsorptionsKyla_ökad =
        j8ärKylaAktivt && j8kylform === "Absorptionskyla" && j8andelAvTotalCh_ökadAnvNyttVärde > 0.005 && j8kylfaktorFjärrvärme > 0
          ? ((j8ÅrligEnergiTransmission * j8ShuntensSystemAndel * j8andelAvTotalCh_ökadAnvNyttVärde) / j8kylfaktorFjärrvärme) * j8ytasombetjänasMedKylaProcent
          : 0;

      ////////////////////////////////////////////

      debug["Ökad energianvändning nytt inställningsvärde"] = {
        "Förändring EL värme (kWh)": j8DeltaElVärme_ökad,
        "Förändring värme (kWh)": j8DeltaVärme_ökad,
        "Förändring elproducerad kyla (kWh/år)": j8DeltaKyla_ökad,
        "Förändring fjärrkyla (kWh/år)": j8DeltaFjärrkyla_ökad,
        "Förändring Absorptionskyla (kWh Fjärrvärme/år)": j8DeltaAbsorptionsKyla_ökad,
        j8summaCh_ökadAnvNyttVärde,
        j8andelAvTotalCh_ökadAnvNyttVärde,
      };

      debug["Beräkning komfortkyla"] = {
        "4. Kylform ": j8kylform,
        Kylfaktor: j8kylfaktor,
        "5. Schablon energi (EL) kyla (kWh/kvm*år)": j8schablonEnergiKyla,
        "6. Yta som betjänas med komfortkyla (%)": j8ytasombetjänasMedKylaProcent,
        "7. Kyla aktivt för aktuellt värmesystem": j8ärKylaAktivt,
        "8. Kylfaktor (Kylproduktion / Fjärrvärme)": j8kylfaktorFjärrvärme,
        "8. Normal energianvändning kyla (kWh/år)": j8normalEnergianvändningKyla,
        "Överkonsumtion elproducerad kyla (kWh/år)": j8överkonsumtionElproduceradKyla,
        "Överkonsumtion fjärrkyla (kWh/år)": j8överkonsumtionFjärrkylaBeräknad,
        "Överkonsumtion Absorptionskyla (kWh Fjärrvärme/år)": j8överkonsumtionAbsoptionsKyla,
      };

      const energislagVärmekälla = bimHandler.energiSlag;
      //  j8Villkor10 : =IF(rond321_pumpstoppInstallning="Saknas";1;0)
      const j8Villkor10 = j8TempPumpstoppSaknas;
      // j8Villkor2 : =IF(AND(j8Villkor10=0;j8formPumpstoppAktiveras="Ja");1;0)§
      const j8Villkor2 = !j8Villkor10 && formData?.pumpstoppAktiveras === "Ja";

      //Funktionskontroll 1
      //j8överkonsumtionInställningPumpstopp = IF(AND(j8Villkor2=1;j8Villkor10=0);MAX(j8överkonsumtionElVärme:j8överkonsumtionVärme);0)
      const j8överkonsumtionInställningPumpstopp = j8Villkor2 ? Math.max(j8överkonsumtionElVärme, j8överkonsumtionVärme) : 0;
      //vilkorFunktionskontroll1 = =IF(AND(j8överkonsumtionInställningPumpstopp>=0,5;j8formPumpstoppAktiveras="Ja");j8överkonsumtionInställningPumpstopp;"")
      const vilkorFunktionskontroll1 = j8överkonsumtionInställningPumpstopp >= 0.5 && formData?.pumpstoppAktiveras === "Ja" ? j8överkonsumtionInställningPumpstopp : "";

      //Funktionskontroll 2
      const villkorFunktionskontroll2 = formData?.pumpstoppAktiveras === "Nej" || j8Villkor10;
      const j8överkonsumtionPumpstoppFel = villkorFunktionskontroll2 ? Math.max(j8överkonsumtionElVärme, j8överkonsumtionVärme) : 0;

      //Funktionskontroll 3
      const j8överkonsumtionKyla1 = j8överkonsumtionElprodKyla;
      //const villkorFunktionskontroll3 =IF(j8överkonsumtionKyla1>0,5;j8överkonsumtionKyla1;"")
      const villkorFunktionskontroll3 = j8överkonsumtionKyla1 > 0.5 ? j8överkonsumtionKyla1 : "";

      //Funktionskontroll 4
      const j8överkonsumtionKyla2 = j8överkonsumtionFjärrkyla;
      //const villkorFunktionskontroll4 =IF(j8överkonsumtionKyla2>0,5;j8överkonsumtionKyla2;"")
      const villkorFunktionskontroll4 = j8överkonsumtionKyla2 > 0.5 ? j8överkonsumtionKyla2 : "";

      //Funktionskontroll 5
      const j8överkonsumtionKyla3 = j8överkonsumtionAbsorbtionskyla;
      //const funktionskontroll5  =IF(j8överkonsumtionKyla3>0,5;j8överkonsumtionKyla3;"")
      const funktionskontroll5 = j8överkonsumtionKyla3 > 0.5 ? j8överkonsumtionKyla3 : "";

      //Funktionskontroll 6
      //j8kwhs_fk6=IF(OR(j8överkonsumtionInställningPumpstopp>0;j8överkonsumtionPumpstoppFel>0);ABS(j8överkonsumtionEL);0)
      const j8kwhs_fk6 = j8överkonsumtionInställningPumpstopp > 0 || j8överkonsumtionPumpstoppFel > 0 ? Math.abs(j8överkonsumtionEL) : 0;
      //const funktionskontroll6  =IF(j8kwhs_fk6>0;j8kwhs_fk6;"")
      const funktionskontroll6 = j8kwhs_fk6 > 0 ? j8kwhs_fk6 : "";
      let fktext6Variant = "";
      //=IF(j8kwhs_fk6>0,1;1;0)
      if (j8kwhs_fk6 > 0.1) fktext6Variant = "_1";
      //=IF(OR(j8kwhs_fk6>0,1;j8TempPumpstopp>j8gränsvärdeOptimeratPumpstopp);0;1)

      //x=IF(OR(j8kwhs_fk6>0,1;j8TempPumpstopp<=j8gränsvärdeOptimeratPumpstopp);0;1)
      if (!(j8kwhs_fk6 > 0.1 || j8TempPumpstopp <= j8gränsvärdeOptimeratPumpstopp)) fktext6Variant = "_3"; //"Avvikelse högt inställt pumpstopp - Se vägledning";

      // const j8Villkor1=IF(j8överkonsumtionInställningPumpstopp+j8överkonsumtionPumpstoppFel=0;1;0)
      const j8Villkor1 = j8överkonsumtionInställningPumpstopp + j8överkonsumtionPumpstoppFel === 0 ? true : false;

      //const j8Villkor6=IF('Grunddata IN'!$B$54=Q7;1;0)
      const j8Villkor6 = moduleData.pumpstoppKontroll === "PUMP I DRIFT";
      //const j8Villkor8=IF(j8ärKylaAktivt="Ja";1;0)
      const j8Villkor8 = j8ärKylaAktivt;
      // const j8Villkor9=IF(j8Villkor6+j8Villkor8=2;1;0)
      const j8Villkor9 = j8Villkor6 && j8Villkor8;
      // const j8Villkor11=IF(j8formStyrandeTemperaturgivareOk="Ja";0;1)
      const j8Villkor11 = formData?.styrandeTemperaturgivareOk === "Nej" ? true : false;
      //Funktionskontroll 7

      //const funktionskontroll7 =IF(j8Villkor1=1;$Q2;"")
      const funktionskontroll7 = j8Villkor1;

      //Funktionskontroll 8
      //const funktionskontroll8 =IF(j8Villkor2=1;BFVJ8_FKText8;"")
      const funktionskontroll8 = j8Villkor2;

      //Funktionskontroll 9
      const funktionskontroll9 = j8Villkor11;

      //Funktionskontroll 10
      const funktionskontroll10 = j8Villkor9;

      if (formData.styrandeTemperaturgivareOk && formData.pumpstoppAktiveras) {
        //Create funktionskontroller only after user has been selectin Ja/Nej in the dropdowns
        if (vilkorFunktionskontroll1) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, vilkorFunktionskontroll1, energislagVärmekälla));
        if (villkorFunktionskontroll2) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, j8överkonsumtionPumpstoppFel, energislagVärmekälla));
        if (villkorFunktionskontroll3) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, villkorFunktionskontroll3, "Kyla (El)"));
        if (villkorFunktionskontroll4) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, villkorFunktionskontroll4, "Kyla (FJK)"));
        if (funktionskontroll5) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, funktionskontroll5, "Kyla (FJV)"));
        if (funktionskontroll6) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 6, funktionskontroll6, "EL (Cirkulationspump)", { variant: fktext6Variant, format: "0Dec" }));
        if (funktionskontroll7) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 7, undefined, ""));
        if (funktionskontroll8) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 8, undefined, ""));
        if (funktionskontroll9) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 9, undefined, ""));
        if (funktionskontroll10) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 10, undefined, ""));
      }
      //Driftoptimeringar
      //Driftoptimering Rule1
      //j8driftoptimering1 =IF(AND(F34=0;F41=0);"";MAX(F34;F41)),  F34 : =j8DeltaElVärme_besp,  F41 : =j8DeltaElVärme_ökad
      const harAngivitNyttVärde = formData?.harAngettNyInställningPumpstopp;
      if (harAngivitNyttVärde === "Ja" && j8nyInställningPumpstopp) {
        const j8driftoptimering1 = Math.max(j8DeltaElVärme_besp, j8DeltaElVärme_ökad);

        if (j8driftoptimering1 > 0) {
          const j8MsgEntry1 =
            j8DeltaElVärme_besp > j8DeltaElVärme_ökad ? globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText1 : globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText7;
          driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 1, j8driftoptimering1, "Värme (EL)"));
        }
        //Driftoptimering Rule2
        //j8driftoptimering2 = F51 : =IF(AND(F35=0;F42=0);"";MAX(F35;F42)),  F35 : =j8DeltaVärme_besp,  F42 : =j8DeltaVärme_ökad
        const j8driftoptimering2 = Math.max(j8DeltaVärme_besp, j8DeltaVärme_ökad);
        if (j8driftoptimering2 > 0) {
          //const j8MsgEntry2 = j8DeltaVärme_besp > j8DeltaVärme_ökad ? globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText2 : globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText8;
          if (j8DeltaVärme_besp > j8DeltaVärme_ökad) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 2, j8driftoptimering2, energislagVärmekälla));
          else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 8, j8driftoptimering2, energislagVärmekälla));
        }
        //Driftoptimering Rule3
        //j8driftoptimering3 =IF(AND(F36=0;F43=0);"";MAX(F36;F43)),  F36 : =j8DeltaKyla_besp,  F43 : =j8DeltaKyla_ökad
        const j8driftoptimering3 = Math.max(j8DeltaKyla_besp, j8DeltaKyla_ökad);
        if (j8driftoptimering3 > 0) {
          // const j8MsgEntry3 = j8DeltaKyla_besp > j8DeltaKyla_ökad ? globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText3 : globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText9;

          if (j8DeltaKyla_besp > j8DeltaKyla_ökad) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, j8driftoptimering3, "Kyla (El)"));
          else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 9, j8driftoptimering3, "Kyla (El)"));
        }
        //Driftoptimering Rule4
        //j8driftoptimering4=IF(AND(F37=0;F44=0);"";MAX(F37;F44)),  F37 : =j8DeltaFjärrkyla_besp,  F44 : =j8DeltaFjärrkyla_ökad
        const j8driftoptimering4 = Math.max(j8DeltaFjärrkyla_besp, j8DeltaFjärrkyla_ökad);
        if (j8driftoptimering4 > 0) {
          // const j8MsgEntry4 =
          //   j8DeltaFjärrkyla_besp > j8DeltaFjärrkyla_ökad ? globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText4 : globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText10;
          if (j8DeltaFjärrkyla_besp > j8DeltaFjärrkyla_ökad) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 4, j8driftoptimering4, "Kyla (FJK)"));
          else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 10, j8driftoptimering4, "Kyla (FJK)"));
        }
        //Driftoptimering Rule5
        //j8driftoptimering5=IF(AND(F38=0;F45=0);"";MAX(F38;F45)),  F38 : =j8DeltaAbsorptionsKyla_besp,  F45 : =j8DeltaAbsorptionsKyla_ökad
        const j8driftoptimering5 = Math.max(j8DeltaAbsorptionsKyla_besp, j8DeltaAbsorptionsKyla_ökad);
        if (j8driftoptimering5 > 0) {
          // const j8MsgEntry5 =
          //   j8DeltaAbsorptionsKyla_besp > j8DeltaAbsorptionsKyla_ökad
          //     ? globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText5
          //     : globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText11;
          if (j8DeltaAbsorptionsKyla_besp > j8DeltaAbsorptionsKyla_ökad) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 5, j8driftoptimering5, "Kyla (FJV)"));
          else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 11, j8driftoptimering5, "Kyla (FJV)"));
        }
        //Driftoptimering Rule6
        //j8driftoptimering6=IF(AND(F39=0;F46=0);"";MAX(F39;F46)),  F39 : =IF(j8FörändringNyttPumpstopp>0,1;j8FörändringNyttPumpstopp;0),  F46 : =IF(j8FörändringNyttPumpstopp>0,1;0;ABS(j8FörändringNyttPumpstopp))
        const j8driftoptimering6 = Math.max(j8FörändringNyttPumpstopp > 0.1 ? j8FörändringNyttPumpstopp : 0, j8FörändringNyttPumpstopp > 0.1 ? 0 : Math.abs(j8FörändringNyttPumpstopp));
        if (j8driftoptimering6 > 0) {
          // const j8MsgEntry6 = j8FörändringNyttPumpstopp > 0 ? globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText6 : globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ8_OptText12;
          if (j8FörändringNyttPumpstopp > 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 6, j8driftoptimering6, "EL (Cirkulationspump)"));
          else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 12, j8driftoptimering6, "EL (Cirkulationspump)"));
        }
      }

      debug["Villkorstabell"] = {
        villlkor1: j8Villkor1,
        villkor2: j8Villkor2,
        villkor6: j8Villkor6,
        villkor8: j8Villkor8,
        villkor9: j8Villkor9,
        villkor10: j8Villkor10,
        villkor11: j8Villkor11,
      };

      return {
        bfName: BFLType.BFV_J8,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        data,
        note: "",
        debug: debug,
        error: error,
      };
    } catch (err: any) {
      return {
        bfName: BFLType.BFV_J8,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: err },
        error: err,
      };
    }
  };

  /// transfers any formdata values to the bf data.
  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (!bfl) return;
    //Sätt default-värden!
    //if (!bfl.data) bfl.data = { nyttVärdeVärmestopp: (module.data as IModuleVärmeEl)?.värmestoppInställningsvärde };
    if (bflForm?.data) {
      bfl.data = { ...bflForm.data };
    }
  };

  return { getResult, bflSpecificPrepareData, bfName };
};

const dflt = { bfv_J8 };

export default dflt;
